import * as React from 'react';

export function Music2Icon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			strokeLinejoin='round'
			strokeLinecap='round'
			strokeWidth={2}
			stroke='currentColor'
			fill='none'
			viewBox='0 0 24 24'
			width={24}
			height={24}
			{...props}
		>
			<circle cx='8' cy='18' r='4' />
			<path d='M12 18V2l7 4' />
		</svg>
	);
}
